<template>
  <div class="edit-quote-line">
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <section-header title="Line Info" />
          <b-row>
            <b-col cols="2">
              <b-form-group label="Quantity">
                <b-form-input type="number" v-model="lineObjCloned.quantity"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Price">
                <b-form-input type="number" v-model="lineObjCloned.price"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Line Total">
                <b-form-input plaintext style="padding-top:0;" v-model="lineTotal"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Buyer Price">
                <b-form-input v-model="lineObjCloned.buyerPrice"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Date Code">
                <b-form-input v-model="lineObjCloned.dateCode"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Lot Code">
                <b-form-input v-model="lineObjCloned.lotCode"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col cols="2">
              <b-form-group label="Part Number">
                <b-form-input v-model="lineObjCloned.partNumber"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Mfr">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.mfr"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Customer Part Number">
                <b-form-input v-model="lineObjCloned.customerPN"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Alternative Part Number">
                <b-form-input v-model="lineObjCloned.alternativePN"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <legend class="col-form-label" for="textarea-small">Description</legend>
              <b-form-textarea plaintext v-model="lineObjCloned.description">

              </b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-form-group label="Category">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.inventoryCategory"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Class">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.class"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Temp">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.tempRating"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Lead Free">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.leadFree"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Package">
                <b-form-input plaintext style="padding-top:0;" v-model="lineObjCloned.package"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <legend class="col-form-label" for="textarea-small">Comment</legend>
              <b-form-textarea v-model="lineObjCloned.comments">

              </b-form-textarea>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  export default {
    props: ['lineObj'],
    data() {
      return {
        lineObjCloned: { ...this.lineObj },
      }
    },
    computed: {
      lineTotal() {
        const total = this.lineObjCloned.quantity * this.lineObjCloned.price;
        return Number(total.toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      },
      ...mapGetters('lookup', [
        'classes',
        'manufacturers',
        'conditions',
        'packaging',
        'referralSources',
        'currencies',
        'uoms'
      ]),
    },
    watch: {
      lineObjCloned: {
        handler() {
          this.$emit('lineObjChange', this.lineObjCloned);
        },
        deep: true,
      },
    },
  }

</script>

<style lang="scss">
  @import '@/assets/scss/_colors.scss';

  .edit-quote-line {
    margin: 10px 0;

    .inline-header {
      margin-bottom: 10px;
      padding-bottom: 5px;
      border-bottom: 1px solid $dirtyWhite;
      color: $mutedGray;
      font-weight: bold;

      &.margin-top {
        margin-top: 20px;
      }
    }

    .buttons-panel {
      margin-top: 10px;
      text-align: right;

      .btn {
        margin-left: 10px;
      }
    }

    .form-control.is-invalid {
      padding-right: 0px;
    }

    .vue-simple-suggest.designed {
      .input-wrapper {
        input {
          height: 27px;
          background: transparent;
          padding-right: 30px;
        }
      }
    }
  }
</style>